import { graphql } from "gatsby";

export type CookieBannerTx = {
  text: string;
  learnMore: string;
  close: string;
};

export default function CookieBanner(_: CookieBannerTx) {
  return null;
}

export const fragments = graphql`
  fragment CookieBanner on Translations {
    text
    learnMore
    close
  }
`;
